import {OnInitialize} from 'overmind'

const onInitialize: OnInitialize = async ({state, actions, effects}) => {
  console.time('init')
  await actions.reloadApp()
  console.timeEnd('init')
}

export default onInitialize
